import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Paragraph from "atoms/typography/paragraph";
import { ViewModes } from "models/enumerations/view-modes/view-modes";
import React from "react";
import { t } from "utilities/localization-utils";
import usePageViewSettings from "./use-page-view-settings";
import { IconSizes } from "atoms/constants/icon-sizes";

const CSS_BASE_CLASS = "c-pages__heading";

const PageListHeader = () => {
    const { viewMode, setViewMode } = usePageViewSettings();
    const handleViewClick = async (newVal: ViewModes) => {
        setViewMode(newVal);
    };
    const isGridButtonActive = viewMode === ViewModes.Grid ? " -active" : "";
    const isListButtonActive = viewMode === ViewModes.List ? " -active" : "";

    return (
        <div className={`${CSS_BASE_CLASS}`}>
            <Paragraph cssClassName={`${CSS_BASE_CLASS}__title`}>
                <Icon
                    type={Icons.Document}
                    size={IconSizes.Large}
                    cssClassName={`${CSS_BASE_CLASS}__title__icon`}
                />
                <span className={`${CSS_BASE_CLASS}__title__text`}>
                    {t("pages")}
                </span>
            </Paragraph>
            <div className={`${CSS_BASE_CLASS}__view-buttons`}>
                <button
                    type="button"
                    className={`${CSS_BASE_CLASS}__view-buttons__button${isGridButtonActive}`}
                    onClick={() => handleViewClick(ViewModes.Grid)}>
                    <Icon type={Icons.GridView} />
                </button>
                <button
                    type="button"
                    className={`${CSS_BASE_CLASS}__view-buttons__button${isListButtonActive}`}
                    onClick={() => handleViewClick(ViewModes.List)}>
                    <Icon type={Icons.List} />
                </button>
            </div>
        </div>
    );
};

export default PageListHeader;
